// Shared by the DOM chapter and both particle renderers. The hold starts only
// after the longest entrance/glint has finished, not when the last card spawns.
const arrivalStart = 0.12;
const arrivalSpan = 7.8;
const enterDuration = 0.56;
const sheenDelay = 0.1;
const sheenDuration = 0.48;
const settledAt = arrivalStart + arrivalSpan + Math.max(enterDuration, sheenDelay + sheenDuration);
const holdDuration = 4;
const exitAt = settledAt + holdDuration;
const exitDuration = 0.6;

export const blessingTiming = {
  cardCount: 72,
  arrivalStart,
  arrivalSpan,
  enterDuration,
  sheenDelay,
  sheenDuration,
  settledAt,
  holdDuration,
  exitAt,
  exitDuration,
  total: exitAt + exitDuration,
} as const;
